<div [class]="'tooltip information-tooltip ' + tooltipCssClass"
     [attr.title]="content">
    <div class="icon-info_inactive tooltip__icon information-tooltip__icon material-icons-outlined">
        info
    </div>
</div>
